import { Container, DefaultPageLayout } from 'routes/components/Layout'
import { LINKS } from 'routes/constants'
import { BreadcrumbsNavigation } from 'routes/components/Shared'
import { BestSupport } from 'routes/components/Features/BestSupport'
import {
  getSolutionsBreadcrumbs,
  PageType,
  SolutionsHeroType,
} from 'routes/Solutions/helpers'
import { SolutionHeadMetatag } from 'routes/Solutions/components/SolutionHeadMetatag'
import { SolutionHero } from 'routes/Solutions/components/SolutionHero'
import { SolutionHIL } from 'routes/Solutions/components/SolutionHIL'
import { SolutionHowItWorks } from 'routes/Solutions/components/SolutionHowItWorks'
import { SolutionCompanies } from 'routes/Solutions/components/SolutionCompanies'
import { SolutionInfrastructure } from 'routes/Solutions/components/SolutionInfrastructure'
import AppsGrid from '../components/SolutionHIL/components/AppsGrid'
import justInTimeMob1x from './just-in-time-integrations-mob@1x.avif'
import justInTimeMob2x from './just-in-time-integrations-mob@2x.avif'
import justInTimeDesk1x from './just-in-time-integrations-desk@1x.avif'
import justInTimeDesk2x from './just-in-time-integrations-desk@2x.avif'
import integrationRequested1x from './integration-requested@1x.png'
import integrationRequested2x from './integration-requested@2x.png'
import explain1x from './explain@1x.png'
import explain2x from './explain@2x.png'
import integrationReady1x from './integration-ready@1x.png'
import integrationReady2x from './integration-ready@2x.png'
import classes from '../solutions.module.scss'

export const pageData: PageType = {
  title: 'On-Demand Integrations',
  href: LINKS.SOLUTIONS.ON_DEMAND_INTEGRATIONS,
  imageSrc: `${justInTimeDesk1x.src}`,
  srcSet: `${justInTimeDesk1x.src} 1x, ${justInTimeDesk2x.src} 2x`,
  description:
    'Create a catalog of thousands of integrations you can ship to your customers with a predictable lead time (1-2 weeks).',
}

const pageHeroData: SolutionsHeroType = {
  title: 'On-Demand Integrations',
  subtitle:
    'Create a catalog of thousands of integrations you can ship to your customers with a predictable lead time (1-2 weeks).',
  imageWidth: '310',
  imageHeight: '945',
  mobile1x: justInTimeMob1x,
  mobile2x: justInTimeMob2x,
  desktop1x: justInTimeDesk1x,
  desktop2x: justInTimeDesk2x,
}

export default function OnDemandIntegrations() {
  const breadcrumbs = getSolutionsBreadcrumbs(pageData.title)

  return (
    <DefaultPageLayout className={classes.page}>
      <SolutionHeadMetatag pageData={pageData} />
      <Container>
        <BreadcrumbsNavigation
          breadcrumbs={breadcrumbs}
          className={classes.breadcrumbs}
        />
      </Container>
      <Container grid>
        <SolutionHero {...pageHeroData} />
        <SolutionHIL
          titles={[
            { text: 'See a catalog of thousands of available integrations' },
            { text: 'If integration is not built yet - request it', h64: true },
            { text: 'Explain what you want integration to do' },
            { text: 'Have integration ready within 1-2 weeks' },
          ]}
        >
          <AppsGrid />
          <img
            srcSet={`${integrationRequested1x.src} 1x, ${integrationRequested2x.src} 2x`}
            src={integrationRequested1x.src}
            alt='Request integration'
            width={443}
            height={108}
            loading='lazy'
          />
          <img
            srcSet={`${explain1x.src} 1x, ${explain2x.src} 2x`}
            src={explain1x.src}
            alt='Explain what you want integration to do'
            width={458}
            height={302}
            loading='lazy'
          />
          <img
            srcSet={`${integrationReady1x.src} 1x, ${integrationReady2x.src} 2x`}
            src={integrationReady1x.src}
            alt='Have integration ready'
            width={566}
            height={372}
            loading='lazy'
          />
        </SolutionHIL>
        <SolutionHowItWorks
          steps={[
            'Select relevant apps and let your customers know you can integrate with them',
            'Collect customer requests for integrations',
            'Contact integration.app team to build the new connector and apply it to your integration use case',
            'Optionally, onboard your team to Connector Builder to not depend on integration.app team',
          ]}
        />
        <SolutionCompanies />
        <SolutionInfrastructure />
        <BestSupport
          isSolutionsSection
          subtitle={
            <>
              Integrations are hard and messy. <br /> Our success team will help
              you every step of the way.
            </>
          }
          className={classes.support}
        />
      </Container>
    </DefaultPageLayout>
  )
}
